import { render } from "./companies.and.sponsors.vue?vue&type=template&id=70570c64"
import script from "./companies.and.sponsors.vue?vue&type=script&lang=js"
export * from "./companies.and.sponsors.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__